import React from "react";
const Flyer = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props?.width || 20}
    height={props?.height || 20}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M16.4583 4.4724V14.9974C16.4583 16.2641 15.4333 17.2891 14.1667 17.2891H8.64167C10.6833 16.8224 14.375 15.5807 14.375 15.5807C14.6167 15.4974 14.7917 15.2724 14.7917 14.9974V3.33073C14.7917 2.06406 13.7667 1.03906 12.5 1.03906H4.16667C2.9 1.03906 1.875 2.06406 1.875 3.33073V13.3307C1.875 14.5974 2.9 15.6224 4.16667 15.6224H6.975V17.2891C7.25 18.2474 8.125 18.9557 9.16667 18.9557H15.8333C17.1 18.9557 18.125 17.9307 18.125 16.6641V6.66406C18.125 5.6224 17.4167 4.7474 16.4583 4.4724ZM5.83333 4.3724H10.8333C11.175 4.3724 11.4583 4.65573 11.4583 4.9974C11.4583 5.33906 11.175 5.6224 10.8333 5.6224H5.83333C5.49167 5.6224 5.20833 5.33906 5.20833 4.9974C5.20833 4.65573 5.49167 4.3724 5.83333 4.3724ZM5.83333 7.70573H10.8333C11.175 7.70573 11.4583 7.98906 11.4583 8.33073C11.4583 8.67239 11.175 8.95573 10.8333 8.95573H5.83333C5.49167 8.95573 5.20833 8.67239 5.20833 8.33073C5.20833 7.98906 5.49167 7.70573 5.83333 7.70573ZM5.20833 11.6641C5.20833 11.3224 5.49167 11.0391 5.83333 11.0391H10.8333C11.175 11.0391 11.4583 11.3224 11.4583 11.6641C11.4583 12.0057 11.175 12.2891 10.8333 12.2891H5.83333C5.49167 12.2891 5.20833 12.0057 5.20833 11.6641Z"
      fill="#6880CF"
    />
  </svg>
);
export default Flyer;
